<template>
  <div style="padding: 0 24px">
    <el-form inline>
      <el-form-item label="标签名称" style="font-size: 16px">
        <el-input v-model="labelName" clearable placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="更新时间" style="font-size: 16px">
        <el-date-picker
          v-model="searchTime"
          :unlink-panels="true"
          type="daterange"
          :clearable="true"
          :editable="false"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="changePageIndex(1)">筛选</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="dialogAddLabel = true">新建</el-button>
      </el-form-item>
      <el-button type="primary" @click="dialogImport = true">导入</el-button>
      <labelImportHistory></labelImportHistory>
    </el-form>
    <el-dialog :visible.sync="dialogAddLabel" title="新建标签" width="490px">
      <div>
        <el-form label-width="120px">
          <el-form-item label="标签名称：" required>
            <el-input
              v-model="newLabel.title"
              placeholder="请输入标签名称"
              :show-word-limit="true"
              :maxlength="32"
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input
              v-model="newLabel.mark"
              placeholder="请输入备注"
              :show-word-limit="true"
              :maxlength="50"
              style="width: 300px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: center">
        <el-button @click="dialogAddLabel = false">取消</el-button>
        <el-button type="primary" @click="addLabel">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogImport"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      title="批量导入标签"
    >
      <el-steps :active="importStatus" align-center>
        <el-step title="选择导入标签"></el-step>
        <el-step title="选择文件"></el-step>
        <el-step title="上传文件"></el-step>
        <el-step title="导入结果"></el-step>
      </el-steps>
      <div class="import-container">
        <div v-show="importStatus === 0">
          <div style="padding-top: 50px; text-align: center">
            <el-select v-model="selectLabel" style="width: 300px">
              <el-option
                v-for="item in labelList"
                :key="item.tag_id"
                :label="item.tag_name"
                :value="item.tag_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div v-show="importStatus === 1">
          <div>
            <el-upload
              ref="upload"
              class="upload"
              drag
              :auto-upload="false"
              :http-request="uploadToCos"
              :before-upload="beforeUpload"
              :on-change="addFile"
              action=""
              :on-remove="handleRemove"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                参照模板整理文件，可将文件拖拽到此区域，或
                <em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                目前仅支持xlsx格式
                <el-button type="text" @click="getImportExcel">下载模板</el-button>
              </div>
            </el-upload>
          </div>
        </div>
        <div v-show="importStatus === 2">
          <div class="import-tips">{{ importTips }}</div>
          <el-progress
            :text-inside="true"
            :stroke-width="24"
            :percentage="uploadPercentage"
          ></el-progress>
        </div>
        <!--样式原因，这边status就是4，不是错误-->
        <div v-show="importStatus === 4">
          <div class="import-tips">
            <div
              style="display: flex; justify-content: center; font-size: 80px; margin-bottom: 20px"
            >
              <i class="el-icon-success" style="color: #76c84d" v-if="uploadSuccess"></i>
              <i class="el-icon-warning" style="color: #ffa600" v-else></i>
            </div>
            <span>{{ uploadRes.status_msg || uploadRes.status_message }}</span>
          </div>
          <div style="margin-top: 40px; text-align: center">
            <span v-if="uploadSuccess">已导入了 {{ uploadRes.add_num }} 条数据</span>
            <span v-if="showTipsFile">
              请点击
              <a :href="uploadRes.tips_file_url">下载文件</a>
              ，查看错误数据
            </span>
          </div>
        </div>
      </div>
      <div style="text-align: right">
        <el-button @click="resetImportStatus" v-show="importStatus !== 4">取消</el-button>
        <el-button type="primary" @click="importNext" v-show="importStatus !== 2">
          {{ importNextTips }}
        </el-button>
      </div>
    </el-dialog>
    <el-table :data="labelList" v-loading="tableLoading">
      <el-table-column prop="tag_name" label="标签名称">
        <template slot-scope="scope">
          <el-popover
            placement="bottom-start"
            title="修改名称"
            width="230"
            trigger="click"
            popper-class="edit_box"
          >
            <div>
              <el-input
                v-model="editTag.tag_name"
                show-word-limit
                maxlength="32"
                @keyup.native.enter="saveEdit()"
              ></el-input>
              <div style="text-align: right; margin-top: 5px">
                <el-button size="mini" @click="closePopover">取消</el-button>
                <el-button size="mini" type="primary" @click="saveEdit()">确定</el-button>
              </div>
            </div>
            <div slot="reference">
              <div class="edit_able" @click="openEdit(scope.row)">
                {{ scope.row.tag_name || '-' }}
              </div>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="depart_num" label="包含部门"></el-table-column>
      <el-table-column prop="user_num" label="包含人数"></el-table-column>
      <el-table-column prop="remark" label="备注">
        <template slot-scope="scope">
          <el-popover
            placement="bottom-start"
            title="修改备注"
            width="230"
            trigger="click"
            popper-class="edit_box"
          >
            <div>
              <el-input
                v-model="editTag.remark"
                show-word-limit
                maxlength="50"
                @keyup.native.enter="saveEdit()"
              ></el-input>
              <div style="text-align: right; margin-top: 5px">
                <el-button size="mini" @click="closePopover">取消</el-button>
                <el-button size="mini" type="primary" @click="saveEdit()">确定</el-button>
              </div>
            </div>
            <div slot="reference">
              <div class="edit_able" @click="openEdit(scope.row)">
                {{ scope.row.remark || '-' }}
              </div>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="update_user" label="创建人"></el-table-column>
      <el-table-column prop="update_time" label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.update_time | handleTime }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="editLabel(scope.row)">编辑</el-button>
          <el-button type="text" @click="deleteLabel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right">
      <el-pagination
        style="background-color: #ffffff"
        layout="total, sizes, prev, pager, next"
        :page-sizes="g_pageSizesConfig"
        :total="pageTotal"
        :page-size="pageSize"
        :current-page="pageIndex"
        @current-change="changePageIndex"
        @size-change="changePageSize"
      />
    </div>
  </div>
</template>

<script>
import {
  CreateContactTag,
  GetContactTagList,
  DeleteContactTag,
  UpdateContactTag,
  CheckTagImportFile,
  GetStaffImportExcelStencil,
  ImportTag,
} from '@/api/addressList';
import { getUploadSignApi } from '@/api/common';
import config from '@/config';
import labelImportHistory from './labelImportHistory';
import { CosMixin } from '@/mixins/cos';
export default {
  name: 'LabelList',
  filters: {
    handleTime(time) {
      if (time) {
        const date = new Date(time * 1000 + 8 * 3600 * 1000);
        return date.toJSON().substr(0, 19).replace('T', ' ').replace(/-/g, '.');
      }
      return '-';
    },
  },
  components: { labelImportHistory },
  mixins: [CosMixin],
  data() {
    return {
      labelName: '',
      searchTime: null,
      labelList: [],
      pageIndex: 1,
      pageSize: 10,
      pageTotal: 1,
      tableLoading: false,

      editTag: {
        tag_id: '',
        tag_name: '',
        remark: '',
      },

      dialogAddLabel: false,
      newLabel: {
        title: '',
        mark: '',
      },

      dialogImport: false,

      importStatus: 0, // 前端导入阶段
      fileUrl: '',
      suffix: '',
      selectLabel: '',
      uploadPercentage: 0,
      importTips: '上传中...',
      uploadSuccess: true,
      showTipsFile: false,
      uploadRes: {
        status: 1,
        status_msg: '',
        template_file_url: '',
        record_id: '',
        tips_file_url: '',
      },
    };
  },
  computed: {
    importNextTips() {
      if (this.importStatus === 4) {
        return '关闭';
      }
      return '下一步';
    },
  },
  watch: {
    dialogAddLabel: {
      handler(val) {
        if (!val) {
          setTimeout(() => {
            // 300是dialog关闭动画的时间
            this.newLabel.title = '';
            this.newLabel.mark = '';
          }, 300);
        }
      },
    },
  },
  created() {
    this.getLabelList();
  },
  methods: {
    getLabelList() {
      this.tableLoading = true;
      GetContactTagList({
        tag_name: this.labelName,
        start_time: this.searchTime ? new Date(this.searchTime[0]).getTime() / 1000 : '',
        end_time: this.searchTime ? new Date(this.searchTime[1]).getTime() / 1000 + 86399 : '',
        page_index: this.pageIndex,
        page_size: this.pageSize,
      })
        .then((res) => {
          this.pageTotal = res.total;
          this.labelList = res.tags;
        })
        .catch((e) => {
          this.message.error(e);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    changePageIndex(val) {
      this.pageIndex = val;
      this.getLabelList();
    },
    changePageSize(val) {
      this.pageSize = val;
      this.getLabelList();
    },
    addLabel() {
      if (this.newLabel.title.length === 0 || this.newLabel.title.match('^[ ]+$')) {
        this.$message.warning('标签名称不能为空');
        return;
      }
      if (this.newLabel.mark.match('^[ ]+$')) {
        this.$message.warning('标签备注不能为空格');
        return;
      }
      CreateContactTag({
        tag_name: this.newLabel.title,
        remark: this.newLabel.mark,
      })
        .then((res) => {
          this.g_tourl(
            `/saas/addressList/labelEdit.html?title=${this.newLabel.title}&id=${res.tag_id}`,
          );
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    editLabel(item) {
      // 进入编辑页面
      this.g_tourl(`/saas/addressList/labelEdit.html?title=${item.tag_name}&id=${item.tag_id}`);
    },
    openEdit({ tag_id, tag_name, remark }) {
      // 打开编辑的popover
      this.editTag = { tag_id, tag_name, remark };
    },
    saveEdit() {
      // 编辑标签的名称和备注
      if (this.editTag.tag_name.length === 0 || this.editTag.tag_name.match('^[ ]+$')) {
        this.$message.warning('标签名称不能为空');
        return;
      }
      if (this.editTag.remark.match('^[ ]+$')) {
        this.$message.warning('标签备注不能为空格');
        return;
      }
      UpdateContactTag(this.editTag)
        .then(() => {
          this.$message.success('修改成功！');
          this.getLabelList();
          this.closePopover();
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    deleteLabel(item) {
      this.$confirm('确定删除标签吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        DeleteContactTag({
          tag_id: item.tag_id,
        })
          .then(() => {
            this.$message.success('删除成功！');
            this.getLabelList();
          })
          .catch((e) => {
            this.$message.error(e);
          });
      });
    },
    closePopover() {
      document.body.click();
    },
    beforeUpload(file) {
      // 上传前判断格式
      if (!/.xlsx$/gi.test(file.name)) {
        this.$message.warning('文件格式与模板不符，请调整后重新上传');
        return false;
      }
      this.suffix = `.${file.name.split('.')[1]}`;
      return true;
    },
    addFile(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleRemove() {
      this.flieUrl = '';
    },
    getImportExcel() {
      GetStaffImportExcelStencil({ type: 1 })
        .then((res) => {
          const a = document.createElement('a');
          a.download = '标签导入模板.xlsx';
          a.href = res.excel_stencil;
          a.click();
          this.$message.success('下载成功');
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    uploadToCos(file) {
      // 文件上传至腾讯云cos
      const pattern = new RegExp(
        "[%--`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——| {}【】‘；：”“'。，、？]",
      );
      const s = file.file.name;
      let rs = '';
      for (let i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
      }
      this.putCosObject(
        {
          imgCosKey: `${file.file.uid}${rs}`,
          fileObject: file.file,
        },
        undefined,
        (progressData) => {
          console.log(progressData);
          this.uploadPercentage = progressData.percent * 20;
        },
        async () => {
          const res = await getUploadSignApi({
            app_id: config.cosAppId,
            credentials: 1,
            suffix: this.suffix,
          });
          const { sessionToken, tmpSecretId, tmpSecretKey } = res?.data?.credentials || {};
          const {
            cdn_url: cdnUrl,
            key,
            startTime,
            expiredTime,
            Region: region,
            Bucket: bucket,
          } = res?.data || {};
          return {
            tmpSecretId,
            tmpSecretKey,
            sessionToken,
            cdnUrl,
            key,
            startTime,
            expiredTime,
            region,
            bucket,
          };
        },
      )
        .then((res) => {
          this.fileUrl = res.data;
          this.importTips = '标签导入中...';
          this.upLoadToBackEnd();
        })
        .catch((e) => {
          console.log(e);
          this.$message.error('文件上传失败');
          this.resetImportStatus();
        });
    },
    proceedUploadPercentage() {
      // 盲目前进进度条
      if (this.uploadPercentage < 80) {
        this.uploadPercentage += 10;
      } else if (this.uploadPercentage < 90) {
        this.uploadPercentage += 2;
      } else if (this.uploadPercentage < 99) {
        this.uploadPercentage += 1;
      }
    },
    upLoadToBackEnd() {
      // 检查格式
      CheckTagImportFile({
        import_file_url: this.fileUrl,
        tag_id: this.selectLabel,
      })
        .then((res) => {
          if (res.status === 6) {
            // 检查通过，轮询等待后端导入结束
            const mission = setInterval(() => {
              ImportTag({ record_id: res.record_id })
                .then((res) => {
                  if ([6, 7].includes(res.status)) {
                    // 仍需等待
                    this.proceedUploadPercentage();
                  } else {
                    if ([8, 10].includes(res.status)) {
                      this.uploadSuccess = false;
                    } else if (res.status === 9) {
                      this.uploadSuccess = true;
                    }
                    // 导入结束
                    clearInterval(mission);
                    this.uploadPercentage = 100;
                    this.uploadRes = res;
                    setTimeout(() => {
                      this.importNext();
                    }, 300);
                  }
                })
                .catch((e) => {
                  clearInterval(mission);
                  this.importTips = `发生错误：${e.message}`;
                });
            }, 2500);
          } else {
            // 格式检查不通过
            this.uploadRes = res;
            this.uploadSuccess = false;
            // 2 4状态时，有需要下载的失败原因文件
            this.showTipsFile = [2, 4].includes(res.status);
            setTimeout(() => {
              this.importNext();
            }, 300);
          }
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    importNext() {
      switch (this.importStatus) {
        case 0:
          if (!this.selectLabel) {
            this.$message.warning('请选择要导入的标签');
            return;
          }
          break;
        case 1:
          if (this.$refs.upload.uploadFiles.length === 0) {
            this.$message.warning('请选择导入文件');
            return;
          }
          this.$refs.upload.submit();
          break;
        case 2:
          // 最后一步要跳两下
          this.importStatus += 1;
          break;
        case 4:
          this.getLabelList();
          this.resetImportStatus();
          break;
      }
      this.importStatus += 1;
    },
    resetImportStatus() {
      // 清空导入进度，300为dialog渐出的时间
      this.dialogImport = false;
      setTimeout(() => {
        this.selectLabel = '';
        this.$refs.upload.clearFiles();
        this.importStatus = 0;
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  max-height: 500px;
}
// 表格鼠标文字编辑悬浮
.edit_able {
  position: relative;
  cursor: pointer;
  padding-right: 10px;
  &:hover {
    // text-decoration: underline;
    // color: #5fa4e8;
    &:after {
      position: absolute;
      //   content: '🖋🖊🖌🖍';
      content: '🖊';
      display: inline-block;
      font-size: 20px;
      padding-left: 5px;
      text-decoration: underline;
    }
  }
}
.import-container {
  height: 240px;
  margin: 20px 0;
}
.import-tips {
  padding-top: 20px;
  margin-bottom: 20px;
  text-align: center;
  font-size: 30px;
}
::v-deep.upload {
  text-align: center;
  .el-upload {
    .el-upload-dragger {
      width: 450px;
      height: 150px;
    }
  }
  .el-upload-list__item-name {
    padding: 0;
    margin: 0;
  }
}
</style>
